import MotoristsApp from "./MotoristsApp";

export default MotoristsApp;
